// App.js
import React, { useEffect } from 'react';
import {
  Routes,
  Route,
  useNavigate,
  Navigate
} from 'react-router-dom';
import { useAuth } from 'react-oidc-context';

import Header from './components/Header';
import DashboardPage from './pages/DashboardPage';
import LoginPage from './pages/LoginPage';

import './App.css';

const ProtectedRoute = ({ children }) => {
  const auth = useAuth();
  if (auth.isLoading) return <div>Loading...</div>;
  return auth.isAuthenticated
    ? children
    : <Navigate to="/login" replace />;
};

export default function App() {
  const auth = useAuth();
  const navigate = useNavigate();

  // 1) Unconditionally register your hook
  useEffect(() => {
    if (auth.isAuthenticated) {
      navigate('/dashboard', { replace: true });
    }
  }, [auth.isAuthenticated, navigate]);

  // 2) Now you can safely early-return for these states:
  if (auth.activeNavigator === 'signinRedirect') {
    return <div>Signing you in…</div>;
  }
  if (auth.activeNavigator === 'signoutRedirect') {
    return <div>Signing you out…</div>;
  }
  if (auth.isLoading) {
    return <div>Loading...</div>;
  }

  // 3) Normal render once OIDC is settled
  return (
    <div className="main">
      {auth.isAuthenticated && (<div
        className="vlogodiv"
        onClick={() => navigate('/dashboard')}
      >
        <img
          alt="Valeo Logo"
          className="vlogo"
          src="/valeoLogo.png"
        />
      </div>)}
      <Header />
      <div className="routeCont">
        <Routes>
          {/* Public login */}
          <Route path="/login" element={<LoginPage />} />

          {/* Protected dashboard */}
          <Route
            path="/dashboard"
            element={
              <ProtectedRoute>
                <DashboardPage />
              </ProtectedRoute>
            }
          />

          {/* Catch-all: send to dashboard if authed, else login */}
          <Route
            path="*"
            element={
              auth.isAuthenticated
                ? <Navigate to="/dashboard" replace />
                : <Navigate to="/login" replace />
            }
          />
        </Routes>
      </div>
    </div>
  );
}
